import React, { memo, useMemo } from 'react';
import colors from 'constants/colors';
import { Icon } from '@Sage/hoi-poi-ui';

import { getBackendBoolean } from 'utils/fm';
import { getFileSvgIcon } from 'components/SvgIcons/getIcons/getFileSvgIcon';

import DragPreview from '../DragPreview';

const FolderDragPreview = memo(({ data, previewKey }) => {
    const icon = useMemo(() => {
        if (!data) return null;
        if (getBackendBoolean(data.is_folder)) {
            return <Icon name="folder" color={colors.primary.white} />;
        }
        const FileSvgIcon = getFileSvgIcon(data.format, getBackendBoolean(data.is_link));
        return <div className="fm-r-2">{React.createElement(FileSvgIcon)}</div>;
    }, [data]);

    const text = useMemo(() => {
        if (previewKey && data?.[previewKey]) {
            return data?.[previewKey];
        } else if (data?.name) {
            return data.name;
        } else return null;
    }, [data, previewKey]);

    return <DragPreview icon={icon} text={text} />;
});

export default FolderDragPreview;
